/**
 * Converts dollar amount to percentage
 */
export function convertDollarToPercentage(
  amount: number,
  totalValue: number,
): number {
  if (amount <= 0 || totalValue <= 0) return 0
  return (amount / totalValue) * 100
}

/**
 * Converts percentage to dollar amount
 */
export function convertPercentageToDollar(
  percentValue: number,
  totalValue: number,
): number {
  if (percentValue <= 0 || totalValue <= 0) return 0
  return (percentValue / 100) * totalValue
}

/**
 * Generates the assignment date as the first day of the next month
 * This is the default behavior for new sleeve creation
 *
 * @returns YYYY-MM-DD
 */
export function generateAssignmentDate() {
  const today = new Date()
  // Get the first day of the next month
  const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)
  // Format as YYYY-MM-DD
  return nextMonth.toISOString().slice(0, 10)
}

/**
 * Generates the assignment date as the first day of the next year
 * This is the default behavior for new sleeve creation
 *
 * @returns YYYY-MM-DD
 */
export function generateAssignmentDateNextYear() {
  const today = new Date()
  // Get the first day of the next year
  const nextYear = new Date(today.getFullYear() + 1, 0, 1)
  // Format as YYYY-MM-DD
  return nextYear.toISOString().slice(0, 10)
}

/**
 * Formats error messages from a nested object
 * @param errors - The error object to format
 * @returns A string of formatted error messages
 */
export const formatErrorMessage = (
  // biome-ignore lint/suspicious/noExplicitAny: Bulk suppression as part of biome migration
  errors: Record<string, any> | undefined,
): string | null => {
  if (!errors) return null

  // Return null for empty objects
  if (Object.keys(errors).length === 0) return null

  for (const key in errors) {
    const error = errors[key]

    // Handle nested errors
    if (error && typeof error === 'object') {
      // If it has a message property directly
      if (error.message) return error.message

      // Check for deeper nesting
      const nestedMessage = formatErrorMessage(error)
      if (nestedMessage) return nestedMessage
    }
  }

  return 'An error occurred'
}
